import Cookies from "js-cookie";
import { useEffect, useState } from "react";

/**
 * @description check canRunAds/catfish_enabled variable from external js file
 * @description check shoule in mobile view
 * @description check cookie key catfishDisplayed, should not be yes
 * @description if all checks pass, return true and set catfishDisplayed cookie to yes, expires in 4 hours
 */
export function useShouldRenderCatfishAd() {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // - check catfish_enabled variable from external js file
    // window.canRunAds = 1; // TODO, force open here for testing
    // window.catfish_enabled = 1; // TODO, force open here for testing
    if (window.canRunAds == undefined || window.catfish_enabled == undefined) {
      return;
    }

    // - check should in mobile view
    const isMobileView = screen.width <= 767;
    if (!isMobileView) {
      return;
    }

    // - check cookie key catfishDisplayed
    const catfishDisplayed = Cookies.get("catfishDisplayed");
    if (catfishDisplayed == "yes") {
      return;
    }

    // - if all checks pass, return return and set catfishDisplayed cookie to yes, expires in 4 hours
    setShouldRender(true);
  }, []);

  return shouldRender;
}
